import React, { useEffect, useState } from "react";
import "./MyStyles/style.css";
import "./MyStyles/responsive.css";

export const Header = () => {
  const [paramValue, setParamValue] = useState("/");

  useEffect(() => {
    const referrer = document.referrer;
    const path = "plans";
    const params = new URLSearchParams(window.location.search);
    const at = params.get("at");

    if (referrer && at) {
      const backURL = referrer + path + "?ut=" + at;
      setParamValue(backURL);
    } else {
      setParamValue("/");
    }
  }, []);

  const goBack = () => {
    if (paramValue && paramValue !== "/") {
      window.location.href = paramValue;
    } else {
      window.location.href = "https://www.vzy.one/";
    }
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg custom-navbar-for-home">
        <div className="container-fluid mobile-res-clss">
          <div className="friendsAndFamilyBackBtn">
            <button onClick={goBack}>
              <img src="./Images/arrow-small-left.png" />
            </button>
          </div>
          <a className="navbar-brand custom-logo" href="https://www.vzy.one/">
            <img
              src="./Images/logo.svg"
              alt="My Logo"
              className="img-fluid clas-of-logo"
            />
          </a>
        </div>
      </nav>
    </div>
  );
};
